import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  CoursePauseRequestPagination,
  COURSE_PAUSE_REQUEST_STATUSES,
  currentPageSelector,
  useFilteredCoursePauseRequests,
} from 'features/courseResume';
import CoursePauseRequestedRequestsTableHeader from '../CoursePauseRequestedRequestsTableHeader';
import CoursePauseRequestedRequestsTableRow from '../CoursePauseRequestedRequestsTableRow';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import styles from './CoursePauseRequestedRequestsTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';

function CoursePauseRequestedRequestsTable() {
  const { requestType } = useParams();
  const currentPage = useSelector(currentPageSelector);
  const { data, isLoading, error, refetch, isFetching } =
    useFilteredCoursePauseRequests({
      requestType,
      coursePauseStatus: COURSE_PAUSE_REQUEST_STATUSES.requested,
    });

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load requested requests"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data?.length > 0) {
    const requestedRequests = data.data;

    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <Table className={styles.root}>
          <CoursePauseRequestedRequestsTableHeader />
          <TableBody className={styles.rows}>
            {requestedRequests?.map((request) => (
              <CoursePauseRequestedRequestsTableRow
                coursePauseRequest={request}
                key={request.id}
              />
            ))}
          </TableBody>
        </Table>
        <ElementSpacePlaceholder elementId="requested-request-pagination" />
        <div
          id="requested-request-pagination"
          className={styles.pagination}
        >
          <CoursePauseRequestPagination
            pageCount={data.meta?.total}
            currentPage={currentPage}
          />
        </div>
      </>
    );
  } else {
    return (
      <ErrorLayout
        title="No requests found!"
        message="No requested pause requests exist at the moment!"
      />
    );
  }
}

export default CoursePauseRequestedRequestsTable;
